import { useGlobalSearchParams, useRouter } from 'expo-router';
import { useResetPassword } from 'features/auth/resetPassword/hooks/useResetPassword/useResetPassword';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SetPassword from 'shared/components/PasswordChangeForm/SetPassword';
import { isWeb } from 'shared/constants/platform';

type Params = {
  identityId: string;
  session: string;
  emailAddress: string;
};

const SetPasswordScreen = () => {
  const { t: authT } = useTranslation('auth', {
    keyPrefix: 'resetPassword.createPassword',
  });
  const { session, emailAddress, identityId } = useGlobalSearchParams<Params>();
  const { resetPassword, dialogContent, setDialogContent, loading } =
    useResetPassword();
  const [isSubmitting, setSubmitting] = useState(false);

  const handleSubmit = async (password: string) => {
    setSubmitting(true);
    await resetPassword({
      password,
      identityId,
      session,
      emailAddress: emailAddress ?? '',
    });
    setSubmitting(false);
  };
  const router = useRouter();

  return (
    <SetPassword
      title={authT('title')}
      header={authT('header')}
      newPasswordLabel={authT('textField.newPassword')}
      confirmPasswordLabel={authT('textField.confirmPassword')}
      confirmPasswordErrorLabel={authT('error.passwordNotMatch')}
      submitButtonLabel={authT('textField.changePassword')}
      onSubmit={handleSubmit}
      loading={loading || isSubmitting}
      dialogContent={dialogContent}
      onDialogClose={() => setDialogContent(undefined)}
      onBack={router.back}
      tryAgainAction={() => setDialogContent(undefined)}
      showErrorScreen={isWeb}
    />
  );
};

export default SetPasswordScreen;
